import * as React from 'react';
import type { IconProps } from '@components/atoms/Icon/icon-prop-types';
import { TILE_COLORS, TileIconFrame } from './TileIconFrame';

const TEST_ID = 'Icon-OrgTile';

/** Top-level organization avatar: a network of nodes on the navy tile. */
export const OrgTileIcon = ({ size = 'small', width, height }: IconProps) => (
    <TileIconFrame size={size} width={width} height={height} testId={TEST_ID}>
        <path
            d="M18.8516 8.40117L5.45156 16.2012L4.94844 15.3371L18.3484 7.53711L18.8516 8.40117Z"
            fill={TILE_COLORS.outline}
        />
        <path d="M12.5 5.66914V17.9691H11.5V5.66914H12.5Z" fill={TILE_COLORS.outline} />
        <path
            d="M5.42096 7.5829L18.876 15.2876L18.3792 16.1554L4.92422 8.45066L5.42096 7.5829Z"
            fill={TILE_COLORS.outline}
        />
        <path
            d="M18.6 16.9691C17.8268 16.9691 17.2 16.3423 17.2 15.5691C17.2 14.7959 17.8268 14.1691 18.6 14.1691C19.3732 14.1691 20 14.7959 20 15.5691C20 16.3423 19.3732 16.9691 18.6 16.9691Z"
            fill={TILE_COLORS.glyph}
        />
        <path
            d="M18.6 16.4691C19.0971 16.4691 19.5 16.0662 19.5 15.5691C19.5 15.0721 19.0971 14.6691 18.6 14.6691C18.1029 14.6691 17.7 15.0721 17.7 15.5691C17.7 16.0662 18.1029 16.4691 18.6 16.4691ZM18.6 17.4691C17.5507 17.4691 16.7 16.6185 16.7 15.5691C16.7 14.5198 17.5507 13.6691 18.6 13.6691C19.6493 13.6691 20.5 14.5198 20.5 15.5691C20.5 16.6185 19.6493 17.4691 18.6 17.4691Z"
            fill={TILE_COLORS.accent}
        />
        <path
            d="M5.2 6.56914C5.9732 6.56914 6.6 7.19594 6.6 7.96914C6.6 8.74234 5.9732 9.36914 5.2 9.36914C4.4268 9.36914 3.8 8.74234 3.8 7.96914C3.8 7.19594 4.4268 6.56914 5.2 6.56914Z"
            fill={TILE_COLORS.glyph}
        />
        <path
            d="M5.2 7.06914C4.70294 7.06914 4.3 7.47208 4.3 7.96914C4.3 8.4662 4.70294 8.86914 5.2 8.86914C5.69706 8.86914 6.1 8.4662 6.1 7.96914C6.1 7.47208 5.69706 7.06914 5.2 7.06914ZM5.2 6.06914C6.24934 6.06914 7.1 6.9198 7.1 7.96914C7.1 9.01848 6.24934 9.86914 5.2 9.86914C4.15066 9.86914 3.3 9.01848 3.3 7.96914C3.3 6.9198 4.15066 6.06914 5.2 6.06914Z"
            fill={TILE_COLORS.outline}
        />
        <path
            d="M11.1 18.68C11.1 18.5806 11.1806 18.5 11.28 18.5H12.72C12.8194 18.5 12.9 18.5806 12.9 18.68V20.12C12.9 20.2194 12.8194 20.3 12.72 20.3H11.28C11.1806 20.3 11.1 20.2194 11.1 20.12V18.68Z"
            fill={TILE_COLORS.glyph}
        />
        <path
            d="M11.1 20.12C11.1 20.2132 11.1708 20.2898 11.2615 20.299L11.28 20.3H12.72C12.8194 20.3 12.9 20.2194 12.9 20.12V18.68C12.9 18.5806 12.8194 18.5 12.72 18.5L12.7199 17.5C13.3716 17.5 13.9 18.0284 13.9 18.6801V20.1199C13.9 20.7716 13.3716 21.3 12.7199 21.3H11.2801C10.6284 21.3 10.1 20.7716 10.1 20.1199V18.6801C10.1 18.0284 10.6284 17.5 11.2801 17.5L11.28 18.5L11.2615 18.501C11.1708 18.5102 11.1 18.5868 11.1 18.68V20.12ZM12.7199 17.5L12.72 18.5H11.28L11.2801 17.5H12.7199Z"
            fill={TILE_COLORS.outline}
        />
        <path
            d="M11.1 3.78C11.1 3.68059 11.1806 3.6 11.28 3.6H12.72C12.8194 3.6 12.9 3.68059 12.9 3.78V5.22C12.9 5.31941 12.8194 5.4 12.72 5.4H11.28C11.1806 5.4 11.1 5.31941 11.1 5.22V3.78Z"
            fill={TILE_COLORS.glyph}
        />
        <path
            d="M11.1 5.22C11.1 5.31317 11.1708 5.38977 11.2615 5.39902L11.28 5.4H12.72C12.8194 5.4 12.9 5.31941 12.9 5.22V3.78C12.9 3.68059 12.8194 3.6 12.72 3.6L12.7199 2.6C13.3716 2.6 13.9 3.12838 13.9 3.78008V5.21992C13.9 5.87162 13.3716 6.4 12.7199 6.4H11.2801C10.6284 6.4 10.1 5.87162 10.1 5.21992V3.78008C10.1 3.12838 10.6284 2.6 11.2801 2.6L11.28 3.6L11.2615 3.60098C11.1708 3.61023 11.1 3.68683 11.1 3.78V5.22ZM12.7199 2.6L12.72 3.6H11.28L11.2801 2.6H12.7199Z"
            fill={TILE_COLORS.accent}
        />
        <path d="M5.20005 14.6928L6.32589 16.5036H4.07422L5.20005 14.6928Z" fill={TILE_COLORS.glyph} />
        <path
            d="M5.20012 13.7643C5.52105 13.7643 5.81914 13.9301 5.9886 14.2026L7.11457 16.0132C7.29259 16.2995 7.30137 16.6599 7.13762 16.9546C6.97383 17.2493 6.66307 17.4321 6.3259 17.4321H4.07434C3.73717 17.4321 3.42641 17.2493 3.26262 16.9546C3.09887 16.6599 3.10765 16.2995 3.28567 16.0132L4.41164 14.2026L4.44485 14.1526C4.61842 13.9099 4.89928 13.7643 5.20012 13.7643ZM4.07422 16.5036H6.32589L5.20005 14.6928L4.07422 16.5036Z"
            fill={TILE_COLORS.accent}
        />
        <path d="M18.7001 7L19.8259 8.81071H17.5742L18.7001 7Z" fill={TILE_COLORS.glyph} />
        <path
            d="M18.7001 6.07148C19.0211 6.07148 19.3191 6.23722 19.4886 6.50977L20.6146 8.32031C20.7926 8.60663 20.8014 8.96702 20.6376 9.26172C20.4738 9.55643 20.1631 9.73926 19.8259 9.73926H17.5743C17.2372 9.73926 16.9264 9.55643 16.7626 9.26172C16.5989 8.96702 16.6076 8.60663 16.7857 8.32031L17.9116 6.50977L17.9448 6.45977C18.1184 6.21704 18.3993 6.07148 18.7001 6.07148ZM17.5742 8.81071H19.8259L18.7001 7L17.5742 8.81071Z"
            fill={TILE_COLORS.outline}
        />
        <path
            d="M10 10.4C10 10.1791 10.1791 10 10.4 10H13.6C13.8209 10 14 10.1791 14 10.4V13.6C14 13.8209 13.8209 14 13.6 14H10.4C10.1791 14 10 13.8209 10 13.6V10.4Z"
            fill={TILE_COLORS.glyph}
        />
        <path
            d="M10.0021 13.6408C10.0226 13.8426 10.1929 14 10.4 14H13.6L13.6408 13.9979C13.8291 13.9788 13.9788 13.8291 13.9979 13.6408L14 13.6V10.4C14 10.1929 13.8426 10.0226 13.6408 10.0021L13.6 10V9C14.3732 9 15 9.6268 15 10.4V13.6C15 14.3732 14.3732 15 13.6 15H10.4C9.6268 15 9 14.3732 9 13.6V10.4C9 9.6268 9.6268 9 10.4 9V10C10.1791 10 10 10.1791 10 10.4V13.6L10.0021 13.6408ZM13.6 9V10H10.4V9H13.6Z"
            fill={TILE_COLORS.accent}
        />
    </TileIconFrame>
);
OrgTileIcon.TEST_ID = TEST_ID;
